import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {WfTeamUserContainerModel} from "../../../../../../models";
import {BaseApiTemplateService, Core2Config} from "../../shared";

@Injectable({providedIn: 'root'})
export class WfTeamUserService extends BaseApiTemplateService<WfTeamUserContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'user-group-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'user-group-links';
    this.httpClient = http;
  }
}
